function originOf(value: string): string | null {
  try {
    const origin = new URL(value).origin;
    return origin === "null" ? null : origin;
  } catch {
    return null;
  }
}

/**
 * The website hosting an embedded demo. Browser-provided signals come first; the
 * `parent` query parameter (set by embed.js) is only a fallback for browsers that
 * expose neither ancestorOrigins nor a referrer.
 */
export function resolveParentOrigin(
  location: Pick<Location, "ancestorOrigins">,
  referrer: string,
  parentParam: string | null,
): string | null {
  const ancestor = location.ancestorOrigins?.length ? location.ancestorOrigins.item(0) : null;
  if (ancestor) {
    return originOf(ancestor);
  }
  if (referrer) {
    const fromReferrer = originOf(referrer);
    if (fromReferrer) {
      return fromReferrer;
    }
  }
  return parentParam ? originOf(parentParam) : null;
}
